var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions-item",on:{"click":_vm.gotoIm}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('z-icon',{staticClass:"questions-item-icon",attrs:{"class-prefix":"zziconfont","name":"arrow-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }